import axios from 'axios'

const base = String(process.env.VUE_APP_API_BASE_URL || 'http://localhost:8091/')
  .trim()
  .replace(/\/?$/, '/')
const url = base + 'ivertex/'

export const http = axios.create({
  baseURL: url,
})

http.defaults.timeout = 8500

http.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default {
  url,
}
